import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/layouts/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import Crm from "@/pages/Crm";
import Atendimentos from "@/pages/Atendimentos";
import Financeiro from "@/pages/Financeiro";
import Projetos from "@/pages/Projetos";
import Cadastros from "@/pages/Cadastros";
import Usuarios from "@/pages/Usuarios";

const FullScreenLoader = () => (
  <div className="min-h-screen bg-nx-dark flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="flex flex-col items-center gap-2">
        <img src="/logo-mark.png" alt="NX" className="h-14 w-auto" />
        <span className="font-mono text-[10px] tracking-[0.45em] text-zinc-400">COMPANY</span>
      </div>
      <div className="w-8 h-8 border-2 border-nx-yellow border-t-transparent rounded-full animate-spin" data-testid="app-loading-spinner" />
    </div>
  </div>
);

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return <Outlet />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected />}>
            <Route path="/app" element={<DashboardLayout />}>
              <Route index element={<DashboardHome />} />
              <Route path="crm" element={<Crm />} />
              <Route path="atendimentos" element={<Atendimentos />} />
              <Route path="financeiro" element={<Financeiro />} />
              <Route path="projetos" element={<Projetos />} />
              <Route path="cadastros" element={<Cadastros />} />
              <Route path="usuarios" element={<Usuarios />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
